module.exports = __webpack_public_path__ + "static/sun-9d65f9d7beb5ceb53d4cda8175607e29.png";